var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatsImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 130,
    viewBox: "0 0 270 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 130,
    fill: "#29293D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_881_13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.973 151.999C108.973 151.999 118.559 102.04 178.017 100.119C235.15 98.273 248.929 69.856 248.99 37.999C250.802 5.21303 281.054 -26.001 337.219 -26.001L329.547 151.999H108.973Z",
    fill: "#FB8045"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.908 38.0594C250.868 54.2392 247.346 69.8874 236.278 81.71C225.205 93.539 206.91 101.186 178.076 102.118C148.94 103.059 132.192 115.73 122.692 128.034C117.921 134.214 114.952 140.338 113.178 144.913C112.379 146.974 111.824 148.715 111.458 149.999H327.713L335.213 -23.9875C281.032 -23.2564 252.652 7.07693 250.908 38.0594ZM108.973 151.999L107.092 151.607L106.633 153.999H331.38L339.225 -28.001H337.219C280.408 -28.001 248.965 3.69373 247.074 37.8839L247.071 37.9394V37.995C247.042 53.6522 243.641 68.1183 233.533 78.916C223.417 89.722 206.257 97.206 177.957 98.12C147.636 99.1 129.863 112.369 119.704 125.525C114.647 132.075 111.504 138.56 109.622 143.413C108.68 145.841 108.052 147.867 107.658 149.295C107.461 150.01 107.322 150.576 107.231 150.969C107.185 151.165 107.152 151.319 107.129 151.426C107.118 151.48 107.109 151.522 107.103 151.552L107.096 151.588L107.094 151.6L107.093 151.604C107.093 151.604 107.092 151.607 108.973 151.999Z",
    fill: "#D02E41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.843 92.02C184.077 92.02 187.509 95.601 187.509 100.019C187.509 104.436 184.077 108.017 179.843 108.017C175.61 108.017 172.178 104.436 172.178 100.019C172.178 95.601 175.61 92.02 179.843 92.02Z",
    fill: "#33334D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.843 94.02C176.671 94.02 174.096 96.704 174.096 100.019C174.096 103.333 176.671 106.017 179.843 106.017C183.017 106.017 185.591 103.333 185.591 100.019C185.591 96.704 183.017 94.02 179.843 94.02ZM170.26 100.019C170.26 94.498 174.55 90.02 179.843 90.02C185.138 90.02 189.427 94.498 189.427 100.019C189.427 105.539 185.138 110.017 179.843 110.017C174.55 110.017 170.26 105.539 170.26 100.019Z",
    fill: "#D02E41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.847 31.0129C254.081 31.0129 257.512 34.5939 257.512 39.0099C257.512 43.4279 254.081 47.0089 249.847 47.0089C245.613 47.0089 242.181 43.4279 242.181 39.0099C242.181 34.5939 245.613 31.0129 249.847 31.0129Z",
    fill: "#33334D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.888 33.0129C245.715 33.0129 243.14 35.6975 243.14 39.0099C243.14 42.3246 245.715 45.0089 248.888 45.0089C252.061 45.0089 254.635 42.3248 254.635 39.0099C254.635 35.6973 252.061 33.0129 248.888 33.0129ZM239.304 39.0099C239.304 33.4903 243.594 29.0129 248.888 29.0129C254.182 29.0129 258.471 33.4905 258.471 39.0099C258.471 44.531 254.182 49.0089 248.888 49.0089C243.594 49.0089 239.304 44.5312 239.304 39.0099Z",
    fill: "#D02E41"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_881_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 182,
    fill: "white",
    transform: "translate(106 -28)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsImg3);
export default __webpack_public_path__ + "static/media/stats_img3.673ca6c72d0e3c3606a5b87443eab7fe.svg";
export { ForwardRef as ReactComponent };